import { ReactNode, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../shared/i18n';
export function I18nProvider({
  children
}: {
  children: ReactNode;
}) {
  return <I18nextProvider i18n={i18n} data-id="element-233">
      <Suspense fallback={null} data-id="element-234">{children}</Suspense>
    </I18nextProvider>;
}